import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import Editable from './Editable';

const MaskedLine = ({ children, delay = 0 }) => (
  <span className="block overflow-hidden pb-1.5 pt-2">
    <motion.span
      className="block"
      initial={{ y: '112%' }}
      animate={{ y: 0 }}
      transition={{ duration: 1.15, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export default function Hero() {
  return (
    <section className="relative pt-16 md:pt-24 pb-6 text-center" data-testid="hero">
      <MaskedLine delay={0.1}>
        <span className="flex items-center justify-center gap-4">
          <span className="h-px w-10 md:w-16 bg-kula-gold/70" />
          <span className="font-display text-xl md:text-3xl text-kula-red leading-normal">শুভ বিবাহ</span>
          <span className="h-px w-10 md:w-16 bg-kula-gold/70" />
        </span>
      </MaskedLine>

      <h1
        className="mt-5 font-display text-kula-maroon text-[11.5vw] leading-[1.5] sm:text-6xl sm:leading-[1.4] md:text-7xl lg:text-[5.4rem]"
        data-testid="hero-names"
      >
        <MaskedLine delay={0.3}>
          <Editable id="bride" placeholder="[Bride's Name]" />
        </MaskedLine>
        <MaskedLine delay={0.46}>
          <span className="inline-flex items-baseline justify-center gap-[0.35em] flex-wrap">
            <span className="font-english italic font-semibold text-kula-gold text-[0.62em]">&amp;</span>
            <Editable id="groom" placeholder="[Groom's Name]" />
          </span>
        </MaskedLine>
      </h1>

      <MaskedLine delay={0.66}>
        <span className="mt-6 inline-block font-bengali text-xs md:text-base tracking-[0.32em] text-kula-red/90">
          <Editable id="date" placeholder="[ WEDDING DATE ]" />
        </span>
      </MaskedLine>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.3, duration: 1 }}
        className="mt-10 flex justify-center text-kula-gold"
      >
        <motion.span animate={{ y: [0, 8, 0] }} transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}>
          <ChevronDown size={22} strokeWidth={1.5} />
        </motion.span>
      </motion.div>
    </section>
  );
}
